export default (kilograms: number) => kilograms * 0.453_592_37
